import { LogErrors } from './../../LogErrors'


const RequestToAPI = async (url, parameters, returnData = true) => {
    try {
        const response = await fetch(url, parameters)
        if (!response.ok) {
            // Manejar errores HTTP
            const errorData = await response.json()
            
            const messageId = errorData.messageId
            
            if (messageId) {
                // Sí se recibió un error 102 del server, avisar que se debe reintentar
                if (messageId === 102) {
                    return { success: false, message: '', retry: true }
                }
            } else {
                //return { success: false, message: errorData.message || 'Error de autenticación' }
                return { success: false, message: errorData.message } //errorCode
            }
        }

        if (returnData) {
            const data = await response.json()
            // Retornar la respuesta exitosa
            return { success: true, data: data }
        } else {
            // Retornar la respuesta exitosa
            return { success: true, data: null }
        }
    } catch (error) {
        await LogErrors('RequestToAPI DL DoubleAttempt', error)
        return { success: false, message: '' }
    }
}

const DoubleAttempt = async (url, parameters, returnData = true) => {
  try {
    const response = await RequestToAPI(url, parameters, returnData)
    
    if (response.success) {
        //console.log("1er intento")
        //console.log(":")
        return { success: true, data: response.data }
    } else {
        const retry = response.retry

        if (retry) {
            const responseRetry = await RequestToAPI(url, parameters, returnData)
            
            if (responseRetry.success) {
                //console.log("2do intento")
                //console.log("::")
                return { success: true, data: responseRetry.data }
            } else {
                return { success: false, message: responseRetry.message}
            }
        } else {
            return { success: false, message: response.message }
        }
    }
  } catch (error) {
    await LogErrors('DoubleAttempt DL DoubleAttempt', error)
    return { success: false, message: '' }
  }
}

export { DoubleAttempt };